import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { PhotoAlbumService } from '../../../../../app/shared/API-Service/services/photo-album.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

import { Image } from '../../../../../images/images'


@Component({
  selector: 'app-view-photo-album',
  templateUrl: './view-photo-album.component.html',
  styleUrls: ['./view-photo-album.component.css']
})
export class ViewPhotoAlbumComponent implements OnInit {
  photoalbums:object [] = [];
  img : string = Image;
  constructor(private _PhotoAlbumService:PhotoAlbumService,private _Router:Router) { }

  ngOnInit(): void {
    this.getphotoalbums();
  }
  getphotoalbums(){
    this._PhotoAlbumService.GetPhotoAlbum().subscribe((res) => {
      this.photoalbums = res.data 
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  update(data){
    this._PhotoAlbumService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertPhotoAlbum']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._PhotoAlbumService.DeletePhotoAlbum(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getphotoalbums();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
